import { useActiveStation } from '@app/core/stations/hooks/useActiveStation';
import { nlpIntegration } from '@mi-front/api-clients';

/**
 * Shape of the resolved live topics station settings (client API returns settings as object).
 * The backend exposes an "enabled" flag for the live topics feature per station.
 */
type LiveTopicsSettingsShape = { enabled?: boolean };

/**
 * Returns whether the live topics feature is enabled for the current (active) station.
 * Uses the station settings API; when loading or on error, returns false.
 */
export function useLiveTopicsEnabledForStation(): boolean {
  const station = useActiveStation();
  const { data, isSuccess } = nlpIntegration.useGetLiveTopicsStationSettings(station.id);

  if (!isSuccess || !data?.settings) {
    return false;
  }

  const settings = data.settings as LiveTopicsSettingsShape;
  return settings.enabled === true;
}
